import {Location} from 'Common/config/PageConfigTypes';
import { useStore } from 'Shared/StoreProvider';

//XXX 
//    OPTION 1: could replace the 'unknown' return types by passing the read-only data down through the Solid components.
//    This would mirror what happens in the the frontend. In addition would need the StoreProviders + location property
//    for the write operations.  
//    ...this MIGHT be the optimal, but note it has a degree of duplication about it.  

//    OPTION 2: cf passing through as props.data.sameInfo rather than props.sameInfo... Would prevent parameter name clashes and discourage use of {...props}
//    ...this MIGHT be the optimal, but note it has a degree of duplication about it and the extra '.data' bit is annoying.
//
//    OPTION 3:The alternative approach is add explicit casts. Eg:
//			const data = storeData(props.location) as Showcase;
//    This approach is somewhat more susceptable to error.
//
//    OPTION 3B: Maybe we can improve the automatic casting of 'subdoc'. Typescript is powerful... possibly too much though...
//               subspect I would need to have something more precise than Location for a start.


/* The length of location can be less than the depth of doc */
export function subdoc<Doc>(doc:Doc,location:Location):unknown 
{
	let data = doc;

	for (let i=0; i<location.length; i++) 
		data = data[location[i]];

	return data;
}

/*
	A little syntactic sugar to help get data from the store. 
	Not it can't be called from event handlers due to use of the store context provider.
	To keep things reactive you need at least one level of indirection - eg

		{data.display}	//OK - this is fine:		const data = storeData(props.location)
		{data()}		//OK - requires				const data = () => storeData(props.location)
		{data} 			//NOT OK

		<ImageUpload image={logo()} />		// OK
		<ImageUpload image={logo} />		// NOT OK
*/
export function storeData(location:Location):unknown
{
	return subdoc(useStore().store,location);
}

export function splitLocation(location:Location)
{
	return [
		location.slice(0,-1),
		location[location.length - 1]
	];
}
